import React from 'react';
import { Box, Typography } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { brandConfig } from '../design/theme';
import EmailRounded from '@mui/icons-material/EmailRounded';
import { AppSourceBadge } from './AppSourceBadge';

// Restack company page on LinkedIn. Used by the social icon in the
// footer brand column.
const LINKEDIN_URL = 'https://www.linkedin.com/company/restackaieditor/';

export const Footer = () => {
  return (
    <Box component="footer" className="home-footer-v2">
      <Box className="home-footer-v2__container">
        {/* Top Section */}
        <Box className="home-footer-v2__top">
          {/* Brand Column */}
          <Box className="home-footer-v2__brand-column">
            <Box className="home-footer-v2__brand">
              <Box className="home-footer-v2__brand-name">
                <brandConfig.icon sx={{ fontSize: 20 }} />
                <span>Restack</span>
              </Box>
              <Typography className="home-footer-v2__brand-tagline">
                AI for Private Equity teams. Builds your deck, model, and memo in your live Office files.
              </Typography>
            </Box>

            {/* Social - an email icon and a LinkedIn icon, so people can see
                they can reach out either by email or on LinkedIn. */}
            <Box className="home-footer-v2__social">
              <Box
                component="a"
                href="mailto:hi@re-stack.com"
                aria-label="Email Restack"
                className="home-footer-v2__social-link"
              >
                <EmailRounded
                  sx={{
                    color: 'rgba(255, 255, 255, 0.85)',
                    transition: 'color 0.2s ease',
                    '&:hover': { color: '#FFFFFF' },
                  }}
                />
              </Box>
              <Box
                component="a"
                href={LINKEDIN_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Restack on LinkedIn"
                className="home-footer-v2__social-link"
              >
                <LinkedInIcon
                  sx={{
                    color: 'rgba(255, 255, 255, 0.85)',
                    transition: 'color 0.2s ease',
                    '&:hover': { color: '#FFFFFF' },
                  }}
                />
              </Box>
            </Box>

            {/* The AppSource listing, as Microsoft's own badge. */}
            <AppSourceBadge height={40} sx={{ mt: 2.5 }} />
          </Box>

          {/* Links Columns */}
          <Box className="home-footer-v2__links-section">
            {/* Product Column */}
            <Box className="home-footer-v2__link-column">
              <Typography className="home-footer-v2__link-heading">Product</Typography>
              {[
                { label: 'For PowerPoint', href: '/product' },
                { label: 'For Excel', href: '/excel' },
                { label: 'For Word', href: '/word' },
                { label: 'Capabilities', href: '/#capabilities' },
                { label: 'Security', href: '/security' },
                { label: 'vs Claude', href: '/vs/claude' },
                { label: 'vs Copilot', href: '/vs/copilot' },
              ].map((link) => (
                <Box
                  key={link.label}
                  component="a"
                  href={link.href}
                  className="home-footer-v2__link"
                >
                  {link.label}
                </Box>
              ))}
            </Box>

            {/* Solutions Column */}
            <Box className="home-footer-v2__link-column">
              <Typography className="home-footer-v2__link-heading">Solutions</Typography>
              {[
                { label: 'Private Equity', href: '/solutions/private-equity' },
                { label: 'Growth Equity', href: '/solutions/growth-equity' },
                { label: 'Consulting', href: '/solutions/consulting' },
              ].map((link) => (
                <Box
                  key={link.label}
                  component="a"
                  href={link.href}
                  className="home-footer-v2__link"
                >
                  {link.label}
                </Box>
              ))}
            </Box>

            {/* Company Column */}
            <Box className="home-footer-v2__link-column">
              <Typography className="home-footer-v2__link-heading">Company</Typography>
              {[
                { label: 'AI Transformation', href: '/ai-transformation' },
                { label: 'Careers', href: '/company#careers' },
                { label: 'News', href: '/news' },
                { label: 'Support', href: '/company#support' },
                { label: 'Contact us', href: 'mailto:hi@re-stack.com' },
              ].map((link) => (
                <Box
                  key={link.label}
                  component="a"
                  href={link.href}
                  className="home-footer-v2__link"
                >
                  {link.label}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>

        {/* Bottom Section - Divider + Copyright */}
        <Box className="home-footer-v2__bottom">
          <Box className="home-footer-v2__bottom-content">
            <Typography className="home-footer-v2__copyright">
              &copy; 2026 Restack Inc. All rights reserved.
            </Typography>
            <Box className="home-footer-v2__bottom-links">
              <Box component="a" href="/privacy" className="home-footer-v2__bottom-link">Privacy</Box>
              <Box component="a" href="/terms" className="home-footer-v2__bottom-link">Terms</Box>
            </Box>
          </Box>
        </Box>

        {/* Large Background Text - Full Width */}
        <Box className="home-footer-v2__big-text">
          <brandConfig.icon className="home-footer-v2__big-icon" />
          <Box component="span" className="home-footer-v2__big-text-inner">
            Restack
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
